import { makeStyles } from '@material-ui/core'
import { COLORS, FONTS } from '../../constants'

// Matches the Chirpyest design language: square corners, black primary,
// Graphik typeface with letter-spacing, whiteStain input fills, lowercase chrome.
export const styles = makeStyles(() => ({
  paper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 460,
    maxWidth: '94%',
    maxHeight: '90vh',
    overflowY: 'auto',
    background: COLORS.white,
    padding: '2rem',
    outline: 'none',
    fontFamily: FONTS.Graphik.GraphikRegular,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '1.5rem',
  },
  eyebrow: {
    fontSize: 11,
    color: COLORS.lightGrey,
    letterSpacing: 1.2,
    textTransform: 'lowercase',
    fontFamily: FONTS.Graphik.GraphikMedium,
    margin: '0 0 4px',
  },
  title: {
    fontSize: 20,
    color: COLORS.black,
    fontFamily: FONTS.Graphik.GraphikMedium,
    textTransform: 'lowercase',
    margin: 0,
  },
  close: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: 22,
    color: COLORS.darkGrey,
    lineHeight: 1,
  },
  intro: {
    fontSize: 13,
    color: COLORS.darkGrey,
    textTransform: 'lowercase',
    margin: '0 0 1.25rem',
    lineHeight: 1.6,
  },
  roleCard: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '15px 16px',
    border: `2px solid ${COLORS.whiteSmoke}`,
    cursor: 'pointer',
    width: '100%',
    marginBottom: 10,
    background: COLORS.white,
    textAlign: 'left',
    fontFamily: 'inherit',
    transition: '0.3s',
    '&:hover': { borderColor: COLORS.black },
  },
  roleTitle: {
    fontSize: 14,
    color: COLORS.black,
    fontFamily: FONTS.Graphik.GraphikMedium,
    textTransform: 'lowercase',
    margin: 0,
  },
  roleDesc: {
    fontSize: 12,
    color: COLORS.lightGrey,
    textTransform: 'lowercase',
    margin: '3px 0 0',
  },
  label: {
    fontSize: 12,
    color: COLORS.black,
    fontFamily: FONTS.Graphik.GraphikMedium,
    letterSpacing: 1,
    textTransform: 'lowercase',
    display: 'block',
    margin: '0 0 6px',
  },
  hint: {
    fontSize: 11,
    color: COLORS.lightGrey,
    textTransform: 'lowercase',
    margin: '0 0 8px',
    lineHeight: 1.5,
  },
  input: {
    fontFamily: FONTS.Graphik.GraphikRegular,
    letterSpacing: 1.2,
    background: COLORS.whiteStain,
    border: `2px solid ${COLORS.whiteStain}`,
    padding: '0 14px',
    height: 46,
    fontSize: 13,
    width: '100%',
    boxSizing: 'border-box',
    outline: 'none',
    '&:focus': { borderColor: COLORS.black },
    '&::placeholder': { color: COLORS.lightGrey },
  },
  textarea: {
    fontFamily: FONTS.Graphik.GraphikRegular,
    letterSpacing: 1.2,
    background: COLORS.whiteStain,
    border: `2px solid ${COLORS.whiteStain}`,
    padding: 14,
    fontSize: 13,
    width: '100%',
    boxSizing: 'border-box',
    outline: 'none',
    resize: 'vertical',
    '&:focus': { borderColor: COLORS.black },
  },
  tabRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginBottom: '1.25rem',
  },
  tab: {
    width: '100%',
    padding: '14px 16px',
    border: `2px solid ${COLORS.whiteSmoke}`,
    background: COLORS.white,
    fontSize: 13,
    fontFamily: FONTS.Graphik.GraphikMedium,
    textTransform: 'lowercase',
    color: COLORS.darkGrey,
    cursor: 'pointer',
    textAlign: 'left',
    transition: '0.3s',
    '&:hover': { borderColor: COLORS.black },
  },
  tabActive: {
    borderColor: COLORS.black,
    background: COLORS.whiteSmoke,
    color: COLORS.black,
  },
  socialRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 12px',
    border: `2px solid ${COLORS.whiteStain}`,
    background: COLORS.whiteStain,
    marginBottom: 8,
  },
  socialRowOn: { borderColor: COLORS.black },
  card: {
    border: `2px solid ${COLORS.whiteSmoke}`,
    padding: '14px 16px',
    cursor: 'pointer',
    marginBottom: 10,
    background: COLORS.white,
    width: '100%',
    textAlign: 'left',
    fontFamily: 'inherit',
    transition: '0.3s',
    '&:hover': { borderColor: COLORS.black },
  },
  cardOn: { borderColor: COLORS.black, background: COLORS.whiteSmoke },
  catHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    padding: '14px 16px',
    border: `2px solid ${COLORS.whiteSmoke}`,
    background: COLORS.white,
    marginBottom: 10,
    gap: 8,
    fontFamily: FONTS.Graphik.GraphikMedium,
  },
  catHeaderAgreed: { borderColor: COLORS.black, background: COLORS.whiteSmoke },
  catBody: {
    padding: '12px 16px 16px',
    border: `2px solid ${COLORS.whiteSmoke}`,
    borderTop: 'none',
    marginTop: -10,
    marginBottom: 10,
    fontSize: 12,
    color: COLORS.darkGrey,
    lineHeight: 1.5,
  },
  prohibitedTag: {
    fontSize: 10,
    fontFamily: FONTS.Graphik.GraphikMedium,
    letterSpacing: 1,
    color: COLORS.dangerRed,
    display: 'inline-block',
    marginBottom: 8,
  },
  consentRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    marginBottom: 12,
    fontSize: 12,
    color: COLORS.darkGrey,
    lineHeight: 1.5,
  },
  summary: {
    background: COLORS.whiteStain,
    padding: '14px 16px',
    marginBottom: '1.25rem',
    fontSize: 12,
    color: COLORS.lightBlack,
    lineHeight: 1.7,
  },
  reviewBox: {
    background: COLORS.whiteSmoke,
    borderLeft: `3px solid ${COLORS.black}`,
    padding: '14px 16px',
    marginBottom: '1.25rem',
  },
  reviewText: {
    fontSize: 12,
    color: COLORS.darkGrey,
    margin: 0,
    lineHeight: 1.6,
  },
  successHeading: {
    fontSize: 17,
    color: COLORS.black,
    fontFamily: FONTS.Graphik.GraphikMedium,
    textTransform: 'lowercase',
    margin: '0 0 10px',
  },
  linkBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '12px 14px',
    background: COLORS.whiteStain,
    marginBottom: 14,
  },
  linkText: {
    fontSize: 12,
    color: COLORS.darkGrey,
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  error: {
    fontSize: 12,
    color: COLORS.dangerRed,
    textTransform: 'lowercase',
    margin: '10px 0 0',
  },
  primaryBtn: {
    width: '100%',
    padding: 0,
    height: 50,
    border: `2px solid ${COLORS.black}`,
    background: COLORS.black,
    fontSize: 13,
    letterSpacing: 1.2,
    fontFamily: FONTS.Graphik.GraphikMedium,
    textTransform: 'lowercase',
    color: COLORS.white,
    cursor: 'pointer',
    marginTop: '1.25rem',
    transition: '0.3s',
    '&:hover': { background: COLORS.white, color: COLORS.black },
    '&:disabled': {
      background: COLORS.ashGrey,
      borderColor: COLORS.ashGrey,
      color: COLORS.white,
      cursor: 'default',
    },
  },
  backBtn: {
    height: 50,
    padding: '0 20px',
    border: `2px solid ${COLORS.black}`,
    background: COLORS.white,
    fontSize: 13,
    letterSpacing: 1.2,
    fontFamily: FONTS.Graphik.GraphikMedium,
    textTransform: 'lowercase',
    color: COLORS.black,
    cursor: 'pointer',
    marginTop: '1.25rem',
    transition: '0.3s',
    '&:hover': { background: COLORS.black, color: COLORS.white },
  },
  btnRow: { display: 'flex', alignItems: 'stretch', gap: 10 },
  rowPrimaryBtn: { flex: '1 1 0%', width: 'auto', minWidth: 0 },
  tileGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 10,
    marginBottom: '1.25rem',
  },
  tile: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    minHeight: 56,
    padding: '10px 12px',
    border: `2px solid ${COLORS.whiteSmoke}`,
    background: COLORS.white,
    fontSize: 12,
    fontFamily: FONTS.Graphik.GraphikMedium,
    textTransform: 'lowercase',
    color: COLORS.darkGrey,
    cursor: 'pointer',
    transition: '0.3s',
    '&:hover': { borderColor: COLORS.black },
  },
  tileOn: {
    borderColor: COLORS.black,
    background: COLORS.whiteSmoke,
    color: COLORS.black,
  },
  tileWide: { gridColumn: '1 / -1' },
  checkRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '10px 4px',
    fontSize: 13,
    color: COLORS.lightBlack,
    cursor: 'pointer',
  },
  pips: { display: 'flex', alignItems: 'center', gap: 5 },
  pip: { width: 8, height: 8, background: COLORS.ashGrey },
  pipOn: { background: COLORS.black },
  smallNote: {
    fontSize: 11,
    color: COLORS.lightGrey,
    textTransform: 'lowercase',
    margin: '4px 0 0',
  },
  addBtn: {
    background: 'none',
    border: 'none',
    color: COLORS.black,
    fontFamily: FONTS.Graphik.GraphikMedium,
    fontSize: 12,
    letterSpacing: 1,
    textTransform: 'lowercase',
    cursor: 'pointer',
    padding: 0,
    marginTop: 4,
    textDecoration: 'underline',
  },
  copyBtn: {
    fontSize: 11,
    padding: '6px 12px',
    border: `2px solid ${COLORS.black}`,
    cursor: 'pointer',
    background: COLORS.white,
    fontFamily: FONTS.Graphik.GraphikMedium,
    textTransform: 'lowercase',
    flexShrink: 0,
  },
  removeFieldBtn: {
    background: 'none',
    border: 'none',
    color: COLORS.lightGrey,
    cursor: 'pointer',
    fontSize: 16,
    lineHeight: 1,
    padding: '0 4px',
    flexShrink: 0,
  },
}))
